    const promoEls = document.querySelectorAll('.announcement-message');
    const promoPrev = document.querySelector('.announcement-inner .announcement-nav:first-child');
    const promoNext = document.querySelector('.announcement-inner .announcement-nav:last-child');
    let promoIndex = 0;
    let promoTimer;

    function renderPromo() {
      if (promoEls.length === 0) return;
      promoEls.forEach((el, index) => {
        el.style.display = index === promoIndex ? 'block' : 'none';
      });
    }

    function nextPromo() {
      if (promoEls.length <= 1) return;
      promoIndex = (promoIndex + 1) % promoEls.length;
      renderPromo();
    }

    function prevPromo() {
      if (promoEls.length <= 1) return;
      promoIndex = (promoIndex - 1 + promoEls.length) % promoEls.length;
      renderPromo();
    }

    function startPromoTimer() {
      stopPromoTimer();
      if (promoEls.length > 1) {
        promoTimer = window.setInterval(nextPromo, 4500);
      }
    }

    function stopPromoTimer() {
      if (!promoTimer) return;
      window.clearInterval(promoTimer);
      promoTimer = undefined;
    }

    promoPrev?.addEventListener('click', () => {
      prevPromo();
      startPromoTimer();
    });
    promoNext?.addEventListener('click', () => {
      nextPromo();
      startPromoTimer();
    });
    promoEls.forEach(el => {
      el.addEventListener('mouseenter', stopPromoTimer);
      el.addEventListener('mouseleave', startPromoTimer);
    });

    renderPromo();
    startPromoTimer();

    const mobileWrap = document.getElementById('site-mobile');
    const mobileStack = document.getElementById('mobile-stack');
    const toggleBtn = document.querySelector('.site-nav-toggle');
    const openButtons = document.querySelectorAll('[data-open-submenu]');
    const closeButtons = document.querySelectorAll('[data-close-mobile]');
    const backButtons = document.querySelectorAll('[data-back-mobile]');
    const secondaryPanels = Array.from(document.querySelectorAll('.mobile-level.secondary'));
    const accordionToggles = Array.from(document.querySelectorAll('[data-accordion-target]'));

    function hidePanel(panel) {
      panel.style.visibility = 'hidden';
      panel.style.transform = 'translateX(100%)';
    }

    function showPanel(panel, transform) {
      panel.style.visibility = 'visible';
      panel.style.transform = transform;
    }

    function closeMobileMenu() {
      mobileWrap.classList.remove('is-open');
      toggleBtn?.classList.remove('is-open');
      const iconHamburger = toggleBtn?.querySelector('.icon-hamburger');
      const iconClose = toggleBtn?.querySelector('.icon-close');
      if (iconHamburger) iconHamburger.style.display = 'block';
      if (iconClose) iconClose.style.display = 'none';

      secondaryPanels.forEach((panel) => {
        panel.style.transform = '';
        panel.style.visibility = '';
        panel.dataset.parentPanel = '';
      });
      accordionToggles.forEach((toggle) => {
        toggle.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        const panelId = toggle.dataset.accordionTarget;
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        panel.style.height = '0px';
        panel.hidden = true;
      });
      mobileStack.classList.remove('show-secondary');
      document.body.style.overflow = '';
    }

    function openMobileMenu() {
      mobileWrap.classList.add('is-open');
      toggleBtn?.classList.add('is-open');
      const iconHamburger = toggleBtn?.querySelector('.icon-hamburger');
      const iconClose = toggleBtn?.querySelector('.icon-close');
      if (iconHamburger) iconHamburger.style.display = 'none';
      if (iconClose) iconClose.style.display = 'block';

      mobileStack.classList.remove('show-secondary');
      secondaryPanels.forEach((panel) => {
        panel.style.transform = '';
        panel.style.visibility = 'hidden';
        panel.dataset.parentPanel = '';
      });
      accordionToggles.forEach((toggle) => {
        toggle.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        const panelId = toggle.dataset.accordionTarget;
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        panel.style.height = '0px';
        panel.hidden = true;
      });
      document.body.style.overflow = 'hidden';
    }

    function openSubmenu(id, opener) {
      const target = document.getElementById(id);
      if (!target) return;

      const currentPanel = opener?.closest('.mobile-level.secondary') || null;

      mobileStack.classList.add('show-secondary');

      if (!currentPanel) {
        secondaryPanels.forEach((panel) => hidePanel(panel));
        target.dataset.parentPanel = '';
        showPanel(target, 'translateX(100%)');
        requestAnimationFrame(() => showPanel(target, 'translateX(0)'));
        return;
      }

      secondaryPanels.forEach((panel) => {
        if (panel !== currentPanel && panel !== target) hidePanel(panel);
      });

      target.dataset.parentPanel = currentPanel.id;
      showPanel(currentPanel, 'translateX(0)');
      showPanel(target, 'translateX(100%)');
      requestAnimationFrame(() => {
        showPanel(currentPanel, 'translateX(-100%)');
        showPanel(target, 'translateX(0)');
      });
    }

    toggleBtn?.addEventListener('click', () => {
      if (mobileWrap.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
    closeButtons.forEach((btn) => btn.addEventListener('click', closeMobileMenu));
    backButtons.forEach(btn => btn.addEventListener('click', (e) => {
      const currentPanel = e.target.closest('.mobile-level.secondary');
      if (currentPanel) {
        const parentId = currentPanel.dataset.parentPanel;
        const parentPanel = parentId ? document.getElementById(parentId) : null;

        if (parentPanel) {
          showPanel(parentPanel, 'translateX(-100%)');
          currentPanel.style.transform = 'translateX(100%)';
          requestAnimationFrame(() => showPanel(parentPanel, 'translateX(0)'));
        } else {
          currentPanel.style.transform = 'translateX(100%)';
          mobileStack.classList.remove('show-secondary');
        }

        setTimeout(() => {
          if (parentPanel) currentPanel.dataset.parentPanel = '';
          hidePanel(currentPanel);
        }, 250);
      }
    }));
    openButtons.forEach((btn) => {
      btn.addEventListener('click', () => openSubmenu(btn.dataset.openSubmenu, btn));
    });

    function closeAccordion(toggle, panel) {
      toggle.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      panel.style.height = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => (panel.style.height = '0px'));
      window.setTimeout(() => (panel.hidden = true), 260);
    }

    function openAccordion(toggle, panel) {
      toggle.classList.add('is-expanded');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = '0px';
      requestAnimationFrame(() => (panel.style.height = `${panel.scrollHeight}px`));
    }

    accordionToggles.forEach((toggle) => {
      const panelId = toggle.dataset.accordionTarget;
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      toggle.addEventListener('click', () => {
        const container = toggle.closest('.mobile-level.secondary');
        const expanded = toggle.getAttribute('aria-expanded') === 'true';

        accordionToggles.forEach((otherToggle) => {
          if (otherToggle === toggle) return;
          if (container && otherToggle.closest('.mobile-level.secondary') !== container) return;
          if (otherToggle.getAttribute('aria-expanded') !== 'true') return;
          const otherPanelId = otherToggle.dataset.accordionTarget;
          const otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
          if (!otherPanel) return;
          closeAccordion(otherToggle, otherPanel);
        });

        if (expanded) closeAccordion(toggle, panel);
        else openAccordion(toggle, panel);
      });
    });

    const desktopNav = document.querySelector('.site-nav-desktop');
    const desktopItems = Array.from(document.querySelectorAll('.site-nav-item')).filter((item) => item.querySelector('.site-nav-panel'));
    const desktopFullItems = desktopItems.filter((item) => item.classList.contains('mega-full'));
    let desktopCloseTimer;

    function getOneCharOffset(trigger) {
      const fontSize = parseFloat(getComputedStyle(trigger).fontSize || '14');
      return fontSize * 0.62;
    }

    function alignDesktopPanel(item) {
      const trigger = item.querySelector('.site-nav-trigger');
      const panel = item.querySelector('.site-nav-panel');
      const inner = panel?.querySelector('.site-panel-inner');
      if (!trigger || !panel) return;

      if (item.classList.contains('mega-full')) {
        const header = document.querySelector('.site-header');
        const nav = document.querySelector('.site-nav-desktop');
        const headerRect = header?.getBoundingClientRect();
        const navRect = nav?.getBoundingClientRect();
        if (headerRect && navRect) panel.style.top = `${Math.round(navRect.bottom - headerRect.top)}px`;
      }

      const triggerRect = trigger.getBoundingClientRect();
      const navListRect = document.querySelector('.site-nav-list').getBoundingClientRect();
      
      // Calculate the text offset inside the trigger button (padding is 6px)
      const textPadding = 6; 
      // Calculate inner padding of the panel
      const panelPadding = 16; // The left padding of .site-panel-inner
      const boxPanelPadding = 24; // The left padding of .mega-box .site-panel-inner

      if (item.classList.contains('mega-box')) {
        const itemRect = item.getBoundingClientRect();
        // Align the text inside the panel with the text inside the trigger
        // The panel's absolute left should offset its own padding
        let left = (triggerRect.left - itemRect.left) + textPadding - boxPanelPadding;
        panel.style.left = `${Math.round(left)}px`;
        
        // Ensure it doesn't overflow the screen or the nav boundaries
        const panelRect = panel.getBoundingClientRect();
        if (panelRect.left < navListRect.left) left += (navListRect.left - panelRect.left);
        if (panelRect.right > navListRect.right) left -= (panelRect.right - navListRect.right);
        panel.style.left = `${Math.round(left)}px`;
      }

      if (item.classList.contains('mega-full') && inner) {
        // Find the first and last nav items to define boundaries
        const allNavItems = document.querySelectorAll('.site-nav-item .site-nav-trigger, .site-nav-link');
        if (!allNavItems.length) return;
        
        const firstNavRect = allNavItems[0].getBoundingClientRect();
        const lastNavRect = allNavItems[allNavItems.length - 1].getBoundingClientRect();

        // The text inside the trigger button has padding (6px)
        const textPadding = 6; 
        // The exact left coordinate of the first letter of the first nav item
        const targetLeft = firstNavRect.left + textPadding;
        
        // Since .site-nav-panel is fixed width 100% left 0, 
        // we just need to set the padding-left of the inner container.
        // We remove any default margin and max-width so it can be manually controlled.
        inner.style.margin = '0';
        inner.style.maxWidth = 'none';
        
        // Set padding to match the targetLeft exactly.
        inner.style.paddingLeft = `${Math.max(0, targetLeft)}px`;
        
        // Ensure the right edge aligns exactly with the end of the text of the last nav item
        // lastNavRect.right gives the right edge of the button. Subtracting textPadding gives the end of the text.
        // We subtract this from window.innerWidth to get the required right padding.
        const targetRight = window.innerWidth - (lastNavRect.right - textPadding);
        inner.style.paddingRight = `${Math.max(0, targetRight)}px`;
      }
    }

    function openDesktopItem(item) {
      desktopItems.forEach((it) => it.classList.toggle('is-open', it === item));
      requestAnimationFrame(() => alignDesktopPanel(item));
    }

    function closeAllDesktopItems() {
      desktopItems.forEach((it) => it.classList.remove('is-open'));
    }

    function scheduleDesktopClose(item) {
      clearTimeout(desktopCloseTimer);
      desktopCloseTimer = setTimeout(() => {
        item.classList.remove('is-open');
      }, 220);
    }

    desktopItems.forEach((item) => {
      const trigger = item.querySelector('.site-nav-trigger');
      const panel = item.querySelector('.site-nav-panel');

      [item, trigger, panel].forEach((el) => {
        el?.addEventListener('mouseenter', () => {
          if (window.innerWidth <= 840) return;
          clearTimeout(desktopCloseTimer);
          openDesktopItem(item);
        });
      });

      [item, trigger, panel].forEach((el) => {
        el?.addEventListener('mouseleave', () => {
          if (window.innerWidth <= 840) return;
          scheduleDesktopClose(item);
        });
      });
    });

    desktopNav?.addEventListener('mouseenter', () => clearTimeout(desktopCloseTimer));
    desktopNav?.addEventListener('mouseleave', () => {
      if (window.innerWidth <= 840) return;
      clearTimeout(desktopCloseTimer);
      closeAllDesktopItems();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 840) {
        closeMobileMenu();
        desktopItems.filter((it) => it.classList.contains('is-open')).forEach((it) => alignDesktopPanel(it));
      } else {
        closeAllDesktopItems();
      }
    });

    // Scroll Behavior
    window.addEventListener('scroll', () => {
      const shouldBeScrolled = window.scrollY > 40;
      const isScrolled = document.body.classList.contains('scrolled');

      if (shouldBeScrolled && !isScrolled) {
        document.body.classList.add('scrolled');
        if (window.innerWidth > 840) requestAnimationFrame(() => desktopItems.filter((it) => it.classList.contains('is-open')).forEach((it) => alignDesktopPanel(it)));
      } else if (!shouldBeScrolled && isScrolled) {
        document.body.classList.remove('scrolled');
        if (window.innerWidth > 840) requestAnimationFrame(() => desktopItems.filter((it) => it.classList.contains('is-open')).forEach((it) => alignDesktopPanel(it)));
      }
    });

    // Enable mouse drag to scroll for mobile featured images
    const sliders = document.querySelectorAll('.mobile-featured');
    sliders.forEach(slider => {
      let isDown = false;
      let startX;
      let scrollLeft;
      let isDragging = false;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isDragging = false;
        slider.classList.add('is-dragging');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
      });
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // scroll-fast multiplier
        if (Math.abs(walk) > 5) {
          isDragging = true;
        }
        slider.scrollLeft = scrollLeft - walk;
      });
      
      // Prevent click if we were dragging
      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      // Prevent native drag on images/links
      const imagesAndLinks = slider.querySelectorAll('img, a');
      imagesAndLinks.forEach(el => {
        el.addEventListener('dragstart', (e) => e.preventDefault());
      });
    });

  
